import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/cn";

type Props = {
  label: string;
  value: ReactNode;
  hint?: string;
  /** When set, the whole tile becomes a link to this route (drill-down). */
  to?: string;
  className?: string;
};

export function KpiTile({ label, value, hint, to, className }: Props) {
  const card = (
    <Card
      className={cn(
        "p-0",
        // Lift the border/shadow on hover only when the tile is a drill-down link.
        to &&
          "h-full transition-colors group-hover:border-primary/50 group-hover:shadow-sm",
        className,
      )}
    >
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          {label}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-semibold tabular-nums">{value}</div>
        {hint ? (
          <div className="mt-1 text-xs text-muted-foreground">{hint}</div>
        ) : null}
      </CardContent>
    </Card>
  );
  if (!to) return card;
  return (
    <Link
      to={to}
      aria-label={label}
      className="group block rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      {card}
    </Link>
  );
}
